// import { styled } from '@mui/material/styles';
import MessageList from "@/pages/components/MessageList";
import { Box, Stack, styled } from '@mui/material';
import { useNavigate } from "react-router-dom";
import RpIcon from '../../components/RpIcon';
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";

const StyledBox = styled(Box)(({theme}) => ({
  color: theme.palette.background.two,
  height: '28px',
  lineHeight: '28px',
  marginTop: '-2px'
}))

function message() {
  const navigate = useNavigate();

  const handleOpen = () => {
  }
  return (
    <>
      <Stack
        sx={{
          flex: 1,
          width: '100%',
          overflowY: 'hidden',
          height: '100%'
        }}
        direction="column">
        <SimpleHeader backEnable

        />
        {/*<Stack*/}
        {/*  sx={{height: '44px', padding: '0 16px'}}*/}
        {/*  direction="row" alignItems="center" justifyContent="space-between">aAaAaAZxZ*/}
        {/*  <RpIcon*/}
        {/*    icon="arrow-left"*/}
        {/*    clickable*/}
        {/*    onClick={() => {*/}
        {/*      navigate(-1, {replace: true})*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</Stack>*/}
        <MessageList onLoad={(data) => {

        }}/>
      </Stack>
    </>
  )
}

export default message
